<template>
  <div class="w-100">
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <v-flex
      v-if="isLoading"
      justify-center
    >
      <u-loader />
    </v-flex>
    <div v-else>
      <b-alert
        v-if="passwordSet"
        variant="success"
        show
        dismissible
      >
        Passwort wurde erfolgreich gesetzt.
      </b-alert>
      <div class="form-group mb-4">
        <b-container class="">
          <b-row class="h4 mb-4">
            Passwort zurücksetzen
          </b-row>
          <b-row class="">
            <label class="mt-3 pl-0 col-3 defaultLabel"> Passwort </label>
            <div class="col-6 pl-0">
              <v-text-field
                id="passwordInput"
                v-model="passwordObject.NewPassword"
                :type="showPassword ? 'text' : 'password'"
                name="input-10-2"
                label="Passwort"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                @click:append="showPassword = !showPassword"
              />
            </div>
          </b-row>
          <b-row class="mt-4">
            <label class="pl-0 mt-3 col-3 defaultLabel">
              Passwort bestätigen
            </label>
            <div class="col-6 pl-0">
              <v-text-field
                id="passwordConfirm"
                v-model="passwordObject.ConfirmPassword"
                :type="showPasswordConfirm ? 'text' : 'password'"
                name="input-10-2"
                label="Passwort bestätigen"
                :append-icon="
                  showPasswordConfirm ? 'visibility' : 'visibility_off'
                "
                @click:append="showPasswordConfirm = !showPasswordConfirm"
              />
            </div>
          </b-row>
        </b-container>
        <button
          title="Bearbeiten"
          class="btn btn-primary ml-2"
          @click="setPassword"
        >
          Passwort setzen
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { UpdateUserPassword } from "@/services/user.service.js";
export default {
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      passwordObject: {
        NewPassword: "",
        ConfirmPassword: "",
      },
      errorObject: null,
      isLoading: false,
      showPassword: false,
      showPasswordConfirm: false,
      passwordSet: false,
    };
  },
  created() {},
  methods: {
    setPassword() {
      this.isLoading = true;
      this.errorObject = null;
      this.passwordSet = false;

      UpdateUserPassword(
        this.userId,
        this.passwordObject,
        () => {
          this.isLoading = false;
          this.passwordSet = true;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style scoped>
.smallActionButton {
  width: 30px;
  height: 30px;
  padding: 1px;
}

.userOverview {
  font-size: small;
  table-layout: fixed;
}

.userOverview thead th:nth-child(6) {
  width: 10%;
}

.userOverview tbody tr {
  border-bottom: 1px solid gainsboro;
}
.userOverview td,
.userOverview th {
  padding: 8px 4px;
}
</style>
